import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ScopeSelectorTreeModel } from "../../app/models/ScopeSelectorTreeModel";
import 'rxjs/add/operator/map';
import { AppConfigService } from './app-config.service';
import { SessionService } from './session.service';


@Injectable()
export class ScopeSelectorService {
  baseURL;
  instanceType;
  Env;
  //getClientsUrl = '/UserProposal/GetClients/00000000-0000-0000-0000-000000000000/null';
  //getDeliveryConstructsUrl = '/UserProposal/CheckAIAAFdsAccess/{e2euid}/{deliverystructureUID}';

  constructor(private http: HttpClient, private sessionService: SessionService,
    private appConfigService: AppConfigService) {
    var data = this.appConfigService.getEnvironment();
    this.baseURL = (data.api.IOMAPIUrl);
    this.instanceType = data.instanceType;
    this.Env = data.Env;
  }
  getClients(): any {
    var url = this.baseURL;
    url = url + "/UserProposal/GetClients/00000000-0000-0000-0000-000000000000/null";
    this.http.get(url, {})
      .subscribe(
        (data: any) => {
          var model = new ScopeSelectorTreeModel();
          var res = model.getClients(data);
          return res;

        }, error => {
          return error;
        }
      )

    return this.http.get(url)
      .map((data) => {
        var model = new ScopeSelectorTreeModel();
        var res = model.getClients(data);
        return res;
      }, (error) => {
        return error;
      });
  }
  getAllClients(): any {
    var url = this.baseURL;
    url = url + "/UserProposal/GetClients/00000000-0000-0000-0000-000000000000/null";
    const headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set("Access-Control-Allow-Origin", "*");

    return this.http.get(url, { headers })
      .map((data) => {
        var model = new ScopeSelectorTreeModel();
        var res = model.getAllClients(data);
        return res;
      }, (error) => {
        return error;
      });

  }

  getDeliveryConstructs(e2EUID: string, deliverystructureUID: string): any {

    var userName = this.sessionService.getUserName();
    var url = this.baseURL;
    if (this.instanceType == "FDS")
    {
      this.baseURL + "/Ticket/SplunkUsage/?userId="+ sessionStorage.getItem("userName");
      url = url + "/Ticket/CheckAIAAFdsAccess?e2euid=" + e2EUID + "&deliverystructureUID=" + deliverystructureUID + "&userId=" + sessionStorage.getItem("userName");
    }
    else
    {
      url = url + "/HistoricalTicket/CheckPAMAccess?clientUId=" + e2EUID + "&deliveryConstrctUId=" + deliverystructureUID;
    }
    return this.http.get(url, {})
      .map((data) => {      
        var model = new ScopeSelectorTreeModel();
        if (this.Env == "FDS_ManualUpload" && this.sessionService.getSessionStorageItem('userType') == "3"){
        var res = model.getDeliveryConstructsHierarchyFDS(data);
          if(this.sessionService.getWSUId() !=null && this.sessionService.getWSUId() !="")
          {
            for(var i=0;i<res.children.length;i++)
            {
              if(res.children[i].id == this.sessionService.getWSUId())
              {
                this.sessionService.setDeliveryConstructName(res.children[i].value);
              }
              else if(res.children[i].children.length>0)
              {
                for(var j=0;j<res.children[i].children.length;j++)
                {
                 if(res.children[i].children[j].id == this.sessionService.getWSUId())
                  {
                    this.sessionService.setDeliveryConstructName(res.children[i].children[j].value);
                    this.sessionService.setParentDeliveryConstructName(res.children[i].value);
                  }
                }
              }
            }
          }
        }
        else{
        var res = model.getDeliveryConstructsHierarchy(data);
        }
        return res;
      }, (error) => {
        return error;
      });
  }
  getFormatedDeliveryStructureForPAM(data: any): any {
    var model = new ScopeSelectorTreeModel();
    var res = model.getDeliveryConstructsHierarchyForPAM(data);
    return res;
  }
  getLeftDeliveryConstructs(e2EUID: string, deliverystructureUID: string): any {

    var userName = this.sessionService.getUserName();
    var url = this.baseURL;
    url = url + "/Ticket/CheckAIAAFdsAccess?e2euid=" + e2EUID + "&deliverystructureUID=" + deliverystructureUID;
    return this.http.get(url, {})
      .map((data) => {
        var model = new ScopeSelectorTreeModel();
        var res = model.getLeftDeliveryConstructsHierarchy(data);
        return res;
      }, (error) => {
        return error;
      });
  }
  // added for custom tree
  getLeftDeliveryConstructsForLeftTree(e2EUID: string, deliverystructureUID: string): any {

    var userName = this.sessionService.getUserName();
    var url = this.baseURL;
    if (this.instanceType == "FDS")
      url = url + "/Ticket/CheckAIAAFdsAccess?e2euid=" + e2EUID + "&deliverystructureUID=" + deliverystructureUID + "&userId=" + sessionStorage.getItem("userName");
    else
      url = url + "/HistoricalTicket/CheckPAMAccess?clientUId=" + e2EUID + "&deliveryConstrctUId=" + deliverystructureUID;
    return this.http.get(url, {})
      .map((data) => {
        //var model = new ScopeSelectorTreeModel();
        //var res = model.getLeftDeliveryConstructsHierarchy(data);
        return data;
      }, (error) => {
        return error;
      });
  }
  // call to get default scope based e2eUID
  getDeliveryConstructbyId(clientUId, e2EUID) {
    var url = this.baseURL;
    if (this.instanceType == "FDS")
      url = url + "/Ticket/CheckAIAAFdsAccess?e2euid=" + e2EUID + "&deliverystructureUID=" + e2EUID + "&userId=" + sessionStorage.getItem("userName");
    else
      url = url + "/HistoricalTicket/CheckPAMAccess?clientUId=" + e2EUID + "&deliveryConstrctUId=" + e2EUID;
    if (e2EUID !== 'null' && e2EUID != 'undefined') {
      return this.http.get(url)
        .map((data) => {
          return data;
        }, (error) => {
          return error;
        });
    }
  }
}
